export function textParser(text, limit) {

    return text ? (text.length > limit ? text.slice(0, limit) + '...' : text) : '';
}

export function getShortName(name = '') {
    return name.replace(/^(\S+\s+\S+).*/, '$1');
}